import { createSelector } from 'reselect';
import { getCollectionsNew } from '../collections';

export const getCollectionDelivery = createSelector([getCollectionsNew], (collection) => ({
  digitalShop: collection.digitalShop
}));
